import React, { PureComponent } from 'react'
import {AutoSuggest} from "./AutoSuggest";

export class AutoSuggestField extends PureComponent {
  state = {value: {}}

  componentDidMount = () => {
    if (this.props.value) {
      this.setState({value: this.valueObject})
    }
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.value !== this.props.value) {
      if (!this.props.valueProvider || this.props.valueProvider(this.state.value) !== this.props.value) {
        this.setState({value: this.valueObject})
      }
    }
  }

  get valueObject() {
    return this.props.objectProvider ? this.props.objectProvider(this.props.value) : this.props.value
  }

  onChange = ({target: {value}}) => {
    if (this.props.valueProvider) {
      this.setState({value})
      this.props.onChange({target: {value: this.props.valueProvider(value)}})
    }
    else {
      this.props.onChange({target: {value}})
    }
  }

  render = () => {
    const {suggestionProvider, labelProvider, objectProvider, valueProvider, ...props} = this.props
    return (
      <AutoSuggest
        labelProvider={labelProvider}
        onSuggestionsFetchRequested={(text, callback, error) => suggestionProvider(text).then(callback).catch(error)}
        {...props}
        value={labelProvider(this.state.value)}
        onChange={this.onChange}
      />
    )
  }
}